/**
 * Smartlook sensitive keys configuration
 *
 * This list is used to identify fields that contain sensitive information
 * such as passwords, tokens, and API keys that should not be recorded.
 * Matching is exact on object keys (case-sensitive).
 */
export const SMARTLOOK_SENSITIVE_KEYS = [
  'password',
  'pass',
  'newPassword',
  'oldPassword',
  'SMTPPassword',
  'smtpPassword',
  'token',
  'accessToken',
  'access_token',
  'refreshToken',
  'refresh_token',
  'companyToken',
  'mfaPendingToken',
  'mfaPendingTokenExpired',
  'code',
  'captchaToken',
  'firstName',
  'middleName',
  'lastName',
  'fullName',
  'identity',
  'mobile',
  'email',
  'idToken',
  'id_token',
  'authorization',
  'apiKey',
  'api_key',
  'secret',
  'clientSecret',
  'client_secret',
] as const

/**
 * Gateway path fragments whose request/response bodies must never be recorded.
 * Matched as case-insensitive substrings of the full request URL.
 */
export const SMARTLOOK_OMIT_URL_PATTERNS = [
  '/auth/',
  '/api-keys',
  '/settings/emails',
  '/settings/email-behavior',
  '/mailer/',
] as const
